import React, { useState, useMemo } from "react";
import { StyledResultsScreen, SearchTriggerButton } from "./styles";
import { Header, BottomNav, ErrorScreen } from "../../components/index";
import SearchModal from "../../components/SearchModal";
import PropertyList from "../../components/PropertyList";
import assets from "../../assets/index";

import { useNavigate, useLocation } from "react-router-dom";

const SearchModalTrigger = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <SearchTriggerButton onClick={() => setModalOpen(true)}>
        <img src={assets.SearchIcon} alt="search-icon" height={20} />
        <p>Find your perfect getaway</p>
      </SearchTriggerButton>
      {isModalOpen && <SearchModal onClose={() => setModalOpen(false)} />}
    </>
  );
};

const ResultsScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  // Get filtered properties from the navigation state or fallback to an empty array
  const properties = state?.properties || [];
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const allUnitsFiltered = properties.flatMap(
    (property: any) => property.units || []
  );
  console.log(allUnitsFiltered);

  if (state.propertiesError) {
    return <ErrorScreen content="Something went wrong! Try again later." />;
  }
  return (
    <StyledResultsScreen>
      <Header />

      <SearchModalTrigger />

      {allUnitsFiltered.length > 0 ? (
        <PropertyList
          properties={allUnitsFiltered}
          onUnitClick={(uid: string) =>
            navigate(
              `/unit/${uid}?fromDate=${queryParams.get(
                "availableFrom"
              )}&toDate=${queryParams.get(
                "availableTo"
              )}&adults=${queryParams.get(
                "numberOfAdults"
              )}&children=${queryParams.get("numberOfChildren")}`
            )
          }
        />
      ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>No properties found. Try adjusting your search criteria!</p>
        </div>
      )}
      <BottomNav />
    </StyledResultsScreen>
  );
};

export default ResultsScreen;
